import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const sncService = {
  getAll,
  InsertOrUpdate,
  getAllActive,
  removerById,
}

async function getAll() {
  return await ApiBudgety.get('SNC/GetAll/', {
    headers: {
      ACCION: MenusSistema.mantenedor_snc.accesos.listar_snc_activas,
      MENU: MenusSistema.mantenedor_snc.id,
    },
  })
}

async function getAllActive() {
  return await ApiBudgety.get('SNC/GetAllActive/', {
    headers: {
      ACCION: MenusSistema.mantenedor_snc.accesos.listar_snc_activas,
      MENU: MenusSistema.mantenedor_snc.id,
    },
  })
}

async function InsertOrUpdate(body) {
  return await ApiBudgety.post('SNC/InsertOrUpdate/', body, {
    headers: {
      ACCION: MenusSistema.mantenedor_snc.accesos.crear_editar_snc,
      MENU: MenusSistema.mantenedor_snc.id,
    },
  })
}

async function removerById(id) {
  return await ApiBudgety.post(`SNC/Delete/${id}`, {
    headers: {
      ACCION: MenusSistema.mantenedor_snc.accesos.activa_desactiva_snc,
      MENU: MenusSistema.mantenedor_snc.id,
    },
  })
}
